export const PlanPurchaseExperienceMainContentMinWidth = 400
export const PlanPurchaseExperienceMainContentMaxWidth = 596
export const PlanPurchaseExperiencePromoContentFullWidth = 376

export const PlanPurchaseExperienceNarrowFieldMaxWidth = 448
